// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__3CCir","icon":"style_icon__3tEy-","title":"style_title__2Jpja"};